// extracted by mini-css-extract-plugin
export default {"table":"CorrectionTable_table__GSkI5","completed":"CorrectionTable_completed__IJ6g2","inProgress":"CorrectionTable_inProgress__s4i-b","pending":"CorrectionTable_pending__raK0r"};